import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign ResizeObserver loop warning from leaflet that triggers
// the CRA dev runtime overlay and blocks pointer events.
const _silenceResizeObserver = (e) => {
  const msg = e?.message || e?.reason?.message || "";
  if (typeof msg === "string" && msg.includes("ResizeObserver loop")) {
    e.stopImmediatePropagation?.();
    e.preventDefault?.();
  }
};
window.addEventListener("error", _silenceResizeObserver);
window.addEventListener("unhandledrejection", _silenceResizeObserver);

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
